import { useEffect, useState } from "react";
import Navbar from "../components/framepart/Navbar/Navbar";
import MainPanel from "../components/framepart/MainPanel/MainPanel";
import FooterBasic from "../components/framepart/Footer/FooterBasic";
import "../styles/main.css";
import HomePage from "../pages/masterpages/HomePage";

// ================================
// Constantes structurelles du layout
// ================================
const NAVBAR_HEIGHT = 45;
const FOOTER_HEIGHT = 40;

const LayoutBasic = ({ children }) => {
 /*  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("corelia_token");

    if (!token) {
      window.location.href = "/login";
      return;
    }

    setIsAuthorized(true);
  }, []);

  if (!isAuthorized) return null; */

  return (
    <div
      className="page-container"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        boxSizing: "border-box",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      <div style={{ height: NAVBAR_HEIGHT, flexShrink: 0 }}>
        <Navbar
          logo={{ src: "/assets/logos/corelia.png", label: "Quantum Corelia" }}
          toolbar={<div style={{ display: "flex", gap: 6 }}>Outils</div>}
        />
      </div>

      <div
        className="Middle-container"
        style={{
          display: "flex",
          height: `calc(100vh - ${NAVBAR_HEIGHT + FOOTER_HEIGHT}px)`,
          boxSizing: "border-box",
          minHeight: 0,
          overflowY: "none",
          flexShrink: 0,
        }}
      >
        <div
          className="Center-container"
          style={{
            height: "100%",
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        >
          <MainPanel
            style={{
              height: "100%",
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              boxSizing: "border-box",
              flexShrink: 0,
            }}
          >
            <HomePage />
          </MainPanel>
        </div>
      </div>

      <div style={{ height: FOOTER_HEIGHT, padding: 0, margin: 0 }}>
        <FooterBasic />
      </div>
    </div>
  );
};

export default LayoutBasic;